import { getOrRefreshFirebaseToken } from "../../config/getFirebaseToken";

export default async function updateBookshelfEquipment(equipmentId, updateData, prefix) {
    const token = await getOrRefreshFirebaseToken();

    const res = await fetch(
        `${prefix}bookshelf/equipment/${equipmentId}`,
        {
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify(updateData),
        }
    );
    return res.json();
}